import stringify from 'fast-json-stable-stringify';

export const dedupeBy = <Item extends Record<string, any>, Key extends string>(
  results: Item[],
  key: Key,
) => {
  const seen: Set<string> = new Set();
  return results.filter((item) => {
    const ref = item[key];
    const existing = seen.has(ref);
    seen.add(ref);
    return !existing;
  });
};

/**
 * Minimal shape for cache merge dedupe (flexible vs priority windows may share `fromTime`).
 */
export type AvailabilityDedupeWindow = {
  fromTime?: unknown;
  tillTime?: unknown;
  duration?: unknown;
};

/**
 * Deduplicate merged availability lists without collapsing distinct windows that share the same
 * `fromTime` (e.g. all-day flexible vs priority hour slots from `add_all_day_sla_window`).
 */
export function dedupeAvailabilityWindows<T extends AvailabilityDedupeWindow>(
  results: ReadonlyArray<T>,
): T[] {
  const seen = new Set<string>();
  return results.filter((item) => {
    const k = stringify({
      fromTime: item.fromTime,
      tillTime: item.tillTime,
      duration: item.duration,
    });
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
}
